import { USER_MESSAGE } from "../actions/User";

const initialState = {
  message: { msgType: "", text: "", key: "" }
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case USER_MESSAGE:
      return {
        ...state,
        message: { msgType: action.msgType, text: action.text, key: action.key }
      };
    default:
      return state;
  }
}
